import { Point } from 'components/site/general/singleSelect/SelectedMarkerV2/Point';
import { useIsKeyHeld } from 'components/site/general/singleSelect/SelectedMarkerV2/useIsKeyHeld';
import { useLocalConfig } from 'hooks/map/useLocalConfig';
import { IXY } from 'react-give-me-map/dist/utils/map/mapTypes';

interface Props {
    xyCoordinates: IXY[];
    color: string;
    isClosedPolygon: boolean;
    maxCoordinatesCount?: number;
    onNewPoint: (xyCoordinates: IXY, index: number) => void;
}
export const AddPoints = (props: Props) => {
    const xyCoordinates = props.xyCoordinates;
    const localConfig = useLocalConfig();
    const [isShiftDown] = useIsKeyHeld('Shift');

    const hiddenPoints = localConfig.useShiftForPolygonUpdate && !isShiftDown;

    if (props.xyCoordinates.length === props.maxCoordinatesCount) {
        return null;
    }

    return (
        <>
            {xyCoordinates
                .slice(0, props.isClosedPolygon ? undefined : -1)
                .map((xyCoordinate, index) => {
                    const isLast = index === xyCoordinates.length - 1;
                    const nextPointIndex = isLast ? 0 : index + 1;

                    const nextXyCoordinate = xyCoordinates[nextPointIndex];
                    const x = (xyCoordinate.x + nextXyCoordinate.x) / 2;
                    const y = (xyCoordinate.y + nextXyCoordinate.y) / 2;

                    const id = x + '|' + y;
                    return (
                        <div
                            key={id}
                            style={{
                                position: 'absolute',
                                left: x,
                                top: y,
                                display: 'inline-block',
                                visibility: hiddenPoints ? 'hidden' : 'visible'
                            }}
                            onClick={() => {
                                props.onNewPoint({ x, y }, nextPointIndex);
                            }}
                        >
                            <Point
                                className={'handle'}
                                width={16}
                                fontSize={12}
                                style={{ pointerEvents: 'all' }}
                                text={'+'}
                                color={'white'}
                            />
                        </div>
                    );
                })}
        </>
    );
};
